import React, { useState, useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'

import PoiTypeMultiSelect from '../components/PoiTypeMultiSelect'
import DisplayPois from './../components/PointsOfInterest/DisplayPois'
import GoogleMap from './../components/PointsOfInterest/GoogleMap'
import config from '../config/config'
import { MANAGE_POI_NEW_PATH } from '../config/routes'
import { AuthContext } from '../contexts/AuthContext'
import PoiTypeThumbnail from './../components/PointOfInterest/PoiTypeThumbnail'
import PageHeroTitle from '../components/PageHeroTitle'

import { usePois } from '../contexts/PoisContext'

const PointsOfInterest = () => {
  const { t } = useTranslation()
  const { isAdmin } = useContext(AuthContext)

  const { pois, poiTypes: allPoiTypes } = usePois()

  // On filtre dans le composant que les poiTypes isEvent = true
  const poiTypes = allPoiTypes.filter((pt) => pt.isEvent === false)

  const [selectedPoiTypes, setSelectedPoiTypes] = useState(() => {
    const savedSelectedTypes = localStorage.getItem('selectedPoiTypes')
    return savedSelectedTypes ? JSON.parse(savedSelectedTypes) : []
  })

  useEffect(() => {
    localStorage.setItem('selectedPoiTypes', JSON.stringify(selectedPoiTypes))
  }, [selectedPoiTypes])

  const handleButtonClick = (name) => {
    setSelectedPoiTypes((prevSelectedPoiTypes) => {
      if (prevSelectedPoiTypes.includes(name)) {
        return prevSelectedPoiTypes.filter((item) => item !== name)
      }
      return [...prevSelectedPoiTypes, name]
    })
  }

  // Filtrer les POIs visibles
  const filteredPois = pois
    ? pois.filter((poi) =>
        selectedPoiTypes.length === 0
          ? true
          : selectedPoiTypes.includes(poi.poiType.name),
      )
    : []

  return (
    <div>
      <NavigationBar />

      <PageHeroTitle
        title={t('POINTS_OF_INTEREST')}
        description={t('POINTS_OF_INTEREST_DESCRIPTION')}
      />

      <div className="p-3">
        {isAdmin && (
          <Link
            to={MANAGE_POI_NEW_PATH}
            className="btn btn-primary btn-margin-10"
          >
            {t('ADD')}
          </Link>
        )}

        <div className="block-wrapper">
          <PoiTypeMultiSelect
            poiTypes={poiTypes}
            selectedPoiTypes={selectedPoiTypes}
            handleButtonClick={handleButtonClick}
          />
        </div>

        {filteredPois.length > 0 && (
          <>
            <GoogleMap
              pois={filteredPois}
              selectedPoiTypes={selectedPoiTypes}
            />
            <DisplayPois pois={filteredPois} />
          </>
        )}

        {config.poiTypesWithThumbnail.some((typeWithThumbnail) =>
          selectedPoiTypes.includes(typeWithThumbnail),
        ) && (
          <>
            <hr />
            <h2 className="mt-5">{t('CATEGORIES')}</h2>
            <div className="row g-4">
              {config.poiTypesWithThumbnail.map((typeWithThumbnail) => {
                const matchedPoiType = poiTypes.find(
                  (poiType) => poiType.name === typeWithThumbnail,
                )
                const isSelected = selectedPoiTypes.includes(typeWithThumbnail)

                return matchedPoiType && isSelected ? (
                  <div
                    className="col-md-6 col-lg-4 d-flex"
                    key={matchedPoiType.name}
                  >
                    <PoiTypeThumbnail poiType={matchedPoiType} />
                  </div>
                ) : null
              })}
            </div>
          </>
        )}

        <div className="text-center mt-5">
          <img
            className="img-fluid rounded"
            src="/images/photos/95cc8f97-0f60-4275-a019-d2f30f928649.jpg"
            alt="Tourroc"
          />
          <p className="text-muted mt-2 fst-italic">{/*Vue Tourroc*/}</p>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default PointsOfInterest
